import { v4 as uuidv4 } from 'uuid';
import { DisclosureContent } from '../../../../vtex-apps/disclosure-layout/DisclosureContent/default';
import { DisclosureLayout } from '../../../../vtex-apps/disclosure-layout/DisclosureLayout/default';
import { DisclosureTrigger } from '../../../../vtex-apps/disclosure-layout/DisclosureTrigger/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { NewsletterInputEmail } from '../../../../vtex-apps/store-newsletter/NewsletterInputEmail/default';
import { NewsletterSubmit } from '../../../../vtex-apps/store-newsletter/NewsletterSubmit/default';
import { NewsletterForm } from '../../../../vtex-apps/store-newsletter/NewsletterForm/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';
import { ListContextRenderer } from '../../../../vtex-apps/list-context/ListContextRenderer/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function FooterMobile() {
	return {
		componentName: 'FooterMobile',
		componentId: uuidv4(),
		componentGroup: 'FooterMobile',
		props: {
			mzTitle: 'MZ | Footer - Mobile',
		},
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'footer-mobile-1',
				},
				[
					FlexLayoutCol(
						{
							blockClass: 'footer-mobile-1-logo',
						},
						[
							VisibilityLayout({ mzTitle: 'MZ | Imagem Footer (On/Off)' }, [
								Image({
									src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046479085-JdNwrJt.png',
								}),
							]),
							VisibilityLayout({ mzTitle: 'MZ | Newsletter Footer (On/Off)' }, [
								NewsletterForm({ blockClass: 'footer-mobile-1-newsletter' }, [
									FlexLayoutRow(
										{
											colSizing: 'auto',
											blockClass: 'footer-mobile-1-newsletter__form',
										},
										[
											RichText({
												text: 'Receba descontos e novidades no seu e-mail',
												blockClass: 'footer-mobile-1-newsletter',
											}),
											FlexLayoutCol(
												{
													blockClass: 'newsletter-input',
												},
												[
													NewsletterInputEmail({
														blockClass: 'footer-mobile-1-newsletter',
														placeholderText: 'Informe seu e-mail',
													}),
													NewsletterSubmit({
														submitButtonLabel: 'Cadastrar',
														blockClass: 'footer-mobile-1-newsletter',
													}),
												],
											),
										],
									),
								]),
							]),
						],
					),
					FlexLayoutCol({}, [
						VisibilityLayout({ mzTitle: 'MZ | Menu A Loja (On/Off)' }, [
							DisclosureLayout({}, [
								DisclosureTrigger(
									{
										blockClass: 'footer-1-disclosure-trigger',
									},
									[
										RichText({
											text: 'A [nome loja]',
											blockClass: 'footer-mobile-1-title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
									],
								),
								DisclosureContent({}, [
									Menu({
										blockClass: 'footer-mobile-1-content__menu-item',
										orientation: 'vertical',
										items: [
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Quem Somos',
													itemType: 'custom',
												},
											}).props,
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Nossas Lojas',
													itemType: 'custom',
												},
											}).props,
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Trabalhe Conosco',
													itemType: 'custom',
												},
											}).props,
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Seja Revendedor',
													itemType: 'custom',
												},
											}).props,
										],
									}),
								]),
							]),
						]),
						VisibilityLayout({ mzTitle: 'MZ | Menu Política e Ajuda (On/Off)' }, [
							DisclosureLayout({}, [
								DisclosureTrigger(
									{
										blockClass: 'footer-1-disclosure-trigger',
									},
									[
										RichText({
											text: 'Política e Ajuda',
											blockClass: 'footer-mobile-1-title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
									],
								),
								DisclosureContent({}, [
									Menu({
										blockClass: 'footer-mobile-1-content__menu-item',
										orientation: 'vertical',
										items: [
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Como comprar no nosso site',
													itemType: 'custom',
												},
											}).props,
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Formas de Compra e Entrega',
													itemType: 'custom',
												},
											}).props,
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Política de Troca e Devolução',
													itemType: 'custom',
												},
											}).props,
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Política de Privacidade LGPD',
													itemType: 'custom',
												},
											}).props,
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Fale Conosco',
													itemType: 'custom',
												},
											}).props,
										],
									}),
								]),
							]),
						]),
						VisibilityLayout({ mzTitle: 'MZ | Menu Sua Conta (On/Off)' }, [
							DisclosureLayout({}, [
								DisclosureTrigger(
									{
										blockClass: 'footer-1-disclosure-trigger',
									},
									[
										RichText({
											text: 'Sua Conta',
											blockClass: 'footer-mobile-1-title',
											textAlignment: 'left',
											textPosition: 'left',
										}),
									],
								),
								DisclosureContent({}, [
									Menu({
										blockClass: 'footer-mobile-1-content__menu-item',
										orientation: 'vertical',
										items: [
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Minha Conta',
													itemType: 'custom',
												},
											}).props,
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Meus Pedidos',
													itemType: 'custom',
												},
											}).props,
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Meus Favoritos',
													itemType: 'custom',
												},
											}).props,
											MenuItem({
												type: 'custom',
												itemProps: {
													type: 'internal',
													href: '/#',
													text: 'Notificação por email',
													itemType: 'custom',
												},
											}).props,
										],
									}),
								]),
							]),
						]),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Coluna Atendimento (On/Off)' }, [
						FlexLayoutCol(
							{
								blockClass: 'footer-mobile-1-content',
							},
							[
								RichText({
									text: '**Atendimento**',
									blockClass: 'footer-mobile-1-title',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								RichText({
									text: 'De segunda a sexta, das 9h as 18h.',
									blockClass: 'footer-mobile-1-content__atendimento',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								RichText({
									text: 'Telefones: **(00) 0000-0000 / (00) 0 0000-0000**',
									blockClass: 'footer-mobile-1-content__atendimento',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								RichText({
									text: 'E-mail: [contato@nomeloja.com.br](mailto:contato@nomeloja.com.br)',
									blockClass: 'footer-mobile-1-content__atendimento',
									textAlignment: 'left',
									textPosition: 'left',
								}),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Coluna Redes Sociais (On/Off)' }, [
						FlexLayoutCol(
							{
								blockClass: 'footer-mobile-1-content',
							},
							[
								RichText({
									text: '**Nossas Redes Sociais**',
									textAlignment: 'left',
									textPosition: 'left',
									blockClass: 'footer-mobile-1-title',
								}),
								FlexLayoutRow(
									{
										horizontalAlign: 'left',
										colSizing: 'auto',
										blockClass: 'footer-mobile-1-social-icons',
										preserveLayoutOnMobile: true,
									},
									[
										StoreImageList(
											{
												height: 12,
												images: [
													{
														description: 'Facebook',
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1683046717711-212365083-5b98cc81-5847-402a-9ab8-290df2ccb242.png',
														link: {
															url: 'https://www.facebook.com/',
															newTab: true,
														},
													},
													{
														description: 'Instagram',
														src: 'https://user-images.githubusercontent.com/53307872/212365091-d67ff0ac-e491-4e2b-bee6-087f6eb20031.png',
														link: {
															url: 'https://www.instagram.com/',
															newTab: true,
														},
													},
													{
														description: 'Twitter',
														src: 'https://user-images.githubusercontent.com/53307872/212365094-c5cd4039-4f34-42e6-9115-e6c034297413.png',
														link: {
															url: 'https://twitter.com/',
															newTab: true,
														},
													},
												],
											},
											[
												ListContextRenderer({
													blockClass: 'footer-mobile-1-social-icons__list',
													listElement: 'ul',
													itemElement: 'li',
												}),
											],
										),
									],
								),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Texto SEO (On/Off)' }, [
						FlexLayoutCol({}, [
							RichText({
								textAlignment: 'LEFT',
								textPosition: 'CENTER',
								text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Malesuada quis sit massa rutrum vestibulum. Consequat neque, sit mattis rutrum ullamcorper in lectus adipiscing. Nisl, natoque mauris lectus cursus. Felis tristique quis faucibus mauris et id massa nulla. Condimentum...',
								blockClass: 'footer-mobile-1-description__text',
							}),
							RichText({
								textAlignment: 'CENTER',
								textPosition: 'CENTER',
								text: '[Loja](/about)',
								blockClass: 'footer-mobile-1-description__link',
							}),
						]),
					]),
				],
			),
			FlexLayoutRow(
				{
					blockClass: 'footer-mobile-1-special',
				},
				[
					VisibilityLayout({ mzTitle: 'MZ | Meios de pagamento (On/Off)' }, [
						FlexLayoutRow(
							{
								blockClass: 'footer-mobile-1-content',
							},
							[
								RichText({
									text: '**Formas de pagamento e bandeiras aceitas**',
									blockClass: 'footer-mobile-1-title-special',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								FlexLayoutRow(
									{
										colSizing: 'auto',
										horizontalAlign: 'left',
										blockClass: 'footer-mobile-1-payment-logo',
										preserveLayoutOnMobile: true,
									},
									[
										StoreImageList(
											{
												height: 36,
												images: [
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-mastercard.png',
														alt: 'MasterCard',
														title: 'MasterCard',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-visa.png',
														alt: 'Visa',
														title: 'Visa',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-hipercard.png',
														alt: 'Hipercard',
														title: 'Hipercard',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-hiper.png',
														alt: 'Hiper',
														title: 'Hiper',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-dinersclub.png',
														alt: 'Diners Club',
														title: 'Diners Club',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-jcb.png',
														alt: 'JCB',
														title: 'JCB',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-discover.png',
														alt: 'Discover',
														title: 'Discover',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166278-payment-system-elo.png',
														alt: 'Elo',
														title: 'Elo',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-payment-system-boleto.png',
														alt: 'Boleto',
														title: 'Boleto',
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166279-payment-system-pix.png',
														alt: 'Pix',
														title: 'Pix',
													},
												],
											},
											[
												ListContextRenderer({
													blockClass: 'footer-mobile-1-payment__list',
													listElement: 'ul',
													itemElement: 'li',
												}),
											],
										),
									],
								),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Selos de Segurança (On/Off)' }, [
						FlexLayoutRow(
							{
								blockClass: 'footer-mobile-1-content',
							},
							[
								RichText({
									text: '**Selos de segurança**',
									blockClass: 'footer-mobile-1-title-special',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								FlexLayoutRow(
									{
										blockClass: 'footer-mobile-1--high',
										fullWidth: true,
										colSizing: 'auto',
										horizontalAlign: 'left',
										preserveLayoutOnMobile: true,
									},
									[
										StoreImageList(
											{
												height: 55,
												images: [
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318216942-eureciclo.png',
														alt: 'Eureciclo',
														title: 'SeloEu Reciclo',
														link: {
															url: '',
														},
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318175602-ebit.png',
														alt: 'Ebit',
														title: 'Selo Ebit',
														link: {
															url: '',
														},
													},
													{
														src: 'https://hefesto-upload-images.s3.amazonaws.com/1676318302329-lets-encrypt.png',
														alt: 'Let`s Encript',
														title: 'Selo Let`s Encript',
														link: {
															url: '',
														},
													},
												],
											},
											[
												ListContextRenderer({
													blockClass: 'footer-mobile-1-security__flags',
													listElement: 'ul',
													itemElement: 'li',
												}),
											],
										),
									],
								),
							],
						),
					]),
					FlexLayoutRow(
						{
							blockClass: 'footer-mobile-1-powered-by',
							preserveLayoutOnMobile: true,
							colSizing: 'auto',
						},
						[
							FlexLayoutCol({}, [
								RichText({
									text: '**Powered by**',
									blockClass: 'footer-mobile-1-powered-by__title',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								Image({
									src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166277-logo-checkout-vtex.png',
									title: 'VTEX',
									link: {
										url: 'https://vtex.com/',
										openNewTab: true,
									},
									blockClass: 'footer-mobile-1',
								}),
							]),
							FlexLayoutCol({}, [
								RichText({
									text: '**Desenvolvido**',
									blockClass: 'footer-mobile-1-powered-by__title',
									textAlignment: 'left',
									textPosition: 'left',
								}),
								Image({
									src: 'https://hefesto-upload-images.s3.amazonaws.com/1657651166276-logo-checkout-maeztra.png',
									title: 'Maeztra',
									link: {
										url: 'https://maeztra.com/',
										openNewTab: true,
									},
									blockClass: 'footer-mobile-1',
								}),
							]),
						],
					),
				],
			),
			FlexLayoutRow(
				{
					blockClass: 'footer-mobile-1',
				},
				[
					FlexLayoutCol(
						{
							blockClass: 'footer-mobile-1-legal__description',
						},
						[
							RichText({
								text: '[NOME EMPRESA] LTDA - CNPJ: 00.000.000/0001-00 [RUA OU AVENIDA], 000 - [BAIRRO], [CIDADE] - [UF], CEP 00000-000',
								blockClass: 'footer-mobile-1-legal-text',
							}),
						],
					),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--footer-mobile-1-background-color', name: 'Background' },
			{
				from: '--brand-color-primary-pure',
				to: '--footer-mobile-1-background-color-2',
				name: 'Background Flags',
			},
			{ from: '--white', to: '--footer-mobile-1-highlight-color-2', name: 'Flags Title' },
			{ from: '--brand-color-secondary-dark', to: '--footer-mobile-1-hover-color', name: 'Hover Color' },
			{ from: '--brand-color-secondary-pure', to: '--footer-mobile-1-main-color', name: 'Main Color' },
			{ from: '--brand-color-primary-pure', to: '--footer-mobile-1-highlight-color', name: 'Menu text' },
			{ from: '--text-color-1', to: '--footer-mobile-1-text-color', name: 'Submenu Text' },
			{ from: '--text-color-1', to: '--footer-mobile-1-legal-color', name: 'Legal Text' },
			{ from: '--brand-color-secondary-pure', to: '--footer-mobile-1-social-color', name: 'Social Media Color' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{
				from: '--font-size-sm',
				to: '--footer-mobile-1-highlight-size',
				name: 'Highlight Size',
			},
			{
				from: '--font-size-sm',
				to: '--footer-mobile-1-menu-size',
				name: 'Menu Text size',
			},
			{
				from: '--font-size-sm',
				to: '--footer-mobile-1-description-size',
				name: 'Description Text size',
			},
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-nano', to: '--footer-1-social-spacing', name: 'Social Media padding' },
			//menu lateral padding
			{ from: '--spacing-nano', to: '--footer-mobile-1-menu-lat-spacing', name: 'Menu padding lateral' },
			//menu padding
			{ from: '--spacing-nano', to: '--footer-mobile-1-menu-ver-spacing', name: 'Menu padding vertical' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: 0, to: '--footer-1-social-radius', name: 'Social Media Border Radius' }],
	},
];
